import type { FaireProductEntity } from "../../entity_types/product";

export const p_m2d53v8p7f: FaireProductEntity = {
  token: "p_m2d53v8p7f",
  type: "product",
  name: "All Natural, Plastic-Free, Zero-Waste Deodorants",
  brandToken: "b_ttb2n52ngz",
  brandName: "BeNat",
  imageUrl:
    "https://cdn.faire.com/fastly/d6ecfffcb5bd6b912f08119e24b105eb063fd96ec4c7d9167fc74d0c6f7a58fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af773d1aeabf0604d76783be92536ed7cc13aaf0f41ad5dc5bede936f445de66.jpeg",
    "https://cdn.faire.com/fastly/e52b13a9504419c268dd7f127ca3d79b48a45313df1d61e79a4803ba1bc223b1.png",
    "https://cdn.faire.com/fastly/29adb8ca187fe60a0e851997b538a356526de088d342d7d3d390e06f09c12fa3.png",
    "https://cdn.faire.com/fastly/e3b2e1e9d4c515462955f5a6ace72aa47b1233de742b5cc88fb4c2cd5c264ea3.jpeg",
    "https://cdn.faire.com/fastly/54723b98672a1637115955c037463dde538291b4361869cc0d9a7fefc3a420fa.png",
    "https://cdn.faire.com/fastly/aceb02f7cd442846380cedb18e52d4e532dba259daf47ab84490013f58795232.png",
    "https://cdn.faire.com/fastly/36e51c2f56cc826fd1cd968ab5cd42a5ce2b10f3835dbfbe0067cc984743277e.jpeg",
    "https://cdn.faire.com/fastly/8efd4ea32ce3fc6a428d02f5dac359e36e34e77b30b6d73a37acab681d6dd1a3.jpeg",
    "https://cdn.faire.com/fastly/77b640af9d3777115a04708bc57cf5193020b82a2c39b3eaca366fd72d82d8c3.jpeg",
    "https://cdn.faire.com/fastly/8f74f8d6fc3ef36e39109020ee057ff1e92e4473781fad4d4e650158e3761524.jpeg",
    "https://cdn.faire.com/fastly/c6484f8b1b74d98cca0c58349bcf0115acdc8adae31c9080bb227e521c18fc4b.jpeg",
  ],
  priceDollars: 10.74,
  description:
    "NOW 40% BIGGER! Get more of what you love with our new, larger deodorant. More product, more value, same effective formula at a great price in a new stylish, compostable, eco-friendly presentation.\nALUMINUM FREE- Crafted with love in small batches using high-quality, all-natural ingredients without aluminum, parabens, phthalates, and talc. Our Natural deodorant contains naturally derived ingredients and essential oil only!\nLONG-LASTING ODOR PROTECTION - 24-Hour Clinically Proven to Keep You Smelling Fresh All Day Long Throughout Your Travel! No clogged pores, so you don't ever have to worry about your travel deodorant running out on you.\nECO FRIENDLY & BIODEGRADABLE: Our All-Natural Deodorant is Perfect for earth lovers and lasts 8 Weeks Long! Eco-friendly, zero-\n\nBeNat’s bestseller- A perfect blend of coconut oil, Beeswax, vegetable emulsifier, cornstarch, baking soda, avocado seed oil, and essential oil that makes a clear formula.",
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:16.573Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
